<template>
  <v-container fluid
               fill-height>
    <v-layout row>
      <v-flex xs12>
        <report-box-download :parking-id="parkingId"></report-box-download>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import parkingService from '@/services/parkingService';
import store from '@/store';
import ReportBoxDownload from '@/components/commons/ReportBoxDownload.vue';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'ParkingReports',
  components: {
    [ReportBoxDownload.name]: ReportBoxDownload
  },
  data() {
    return {
      dates: [],
      parkingId: this.$route.params.id,
      parking: {
        billing: {
          name: '',
          email: '',
          CIF: '',
          address: '',
          phone: '',
          accountNumber: ''
        }
      }
    };
  },
  created() {
    if (store.state.parkingSelected !== null && this.parkingId === store.state.parkingSelected) {
      this.parking = store.state.parkingSelected;
    }
    this.loadData();
  },
  destroyed() {},
  methods: {
    loadData() {
      let params = {
        parking: this.parkingId
      };
      parkingService.summary(params, this.summarySuccessHandler, this.summaryErrorHandler);
    },
    summarySuccessHandler(data) {
      this.parking = data;
      store.commit('UPDATE_PARKING_SELECTED', this.parking);
    },
    summaryErrorHandler(error) {
      if (error.status === 404) {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: 'error_404',
          type: 'error'
        });
      }

      this.$router.push({ name: 'Dashboard' });
    }
  }
};
</script>
<style lang="scss" scoped>
h1.table-title,
.panel .panel-heading .panel-title {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 0;
  color: #000;
}

.panel-body span {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/parking/Reports.vue